export const dashboard = {
  'dashboard.title': 'Tableau de Bord Consultant',
  'dashboard.subtitle': 'Gérez votre portefeuille client et suivez les demandes de subventions',
  'dashboard.header.title': 'Tableau de bord',
  'dashboard.header.subtitle': 'Que devriez-vous faire aujourd\'hui ?',
  'dashboard.header.whatShouldYouDo': 'Que devriez-vous faire aujourd\'hui ?',
  'dashboard.profiles.title': 'Vos profils',
  'dashboard.profiles.subtitle': 'Gérez vos profils Clients: création manuelle ou importation, modification et suppression. Découvrez les financements éligibles et historiques de recherches',
  'dashboard.profiles.manageProfiles': 'Gérez vos profils Clients: création manuelle ou importation, modification et suppression. Découvrez les financements éligibles et historiques de recherches',
  'dashboard.createProfile.title': 'Ajouter un nouveau profil de candidature pour accéder à plus d\'opportunités de financement',
  'dashboard.createProfile.newProfile': 'Nouveau Client',
  'dashboard.createProfile.createNewProfile': 'Créer un nouveau profil',
  'dashboard.findOpportunities': 'Trouver des opportunités',
  'dashboard.noProfiles': 'Aucun profil trouvé',
  'dashboard.noProfilesDesc': 'Commencez par créer votre premier profil pour découvrir les opportunités de financement.',
  'dashboard.createYourFirstProfile': 'Créez votre premier profil',
  'dashboard.clientDashboard': 'Tableau de Bord Entreprises Clients',
  'dashboard.clientSubtitle': 'Supervisez les entreprises clientes et surveillez leurs progrès de demande de subvention',
  'dashboard.metrics': 'Métriques Consultant',
  'dashboard.totalClients': 'Total Clients',
  'dashboard.totalSubmissions': 'Total Soumissions',
  'dashboard.averageMatchScore': 'Score de Correspondance Moyen',
  'dashboard.sortBy': 'Trier par',
  'dashboard.statusBreakdown': 'Aperçu du Statut Client',
  'dashboard.pendingTasks': 'Tâches en Attente',
  'dashboard.regionSummary': 'Régions Gérées',
  'dashboard.matchPerformance': 'Résumé de Correspondance de Subventions',
  'dashboard.clientsInReview': 'Clients en Révision',
  'dashboard.newSubsidyMatches': 'Nouveaux Résultats de Subventions',
  'dashboard.pendingDocuments': 'Documents en Attente',
  'dashboard.mostActiveRegion': 'Région la Plus Active',
  'dashboard.filterByStatus': 'Filtrer par Statut',
  'dashboard.filterByRegion': 'Filtrer par Région',
  'dashboard.alertsAndActions': 'Alertes et Actions',
  'dashboard.clientUpdateLog': 'Journal de Mise à Jour Client',
  'dashboard.upcomingDeadlines': 'Échéances à Venir',
  'dashboard.reminders': 'Rappels',
  'dashboard.daysLeft': 'jours restants',
  'dashboard.allClients': 'Tous les Clients',
  'dashboard.onboarding.clientCards': 'Chaque carte montre une de vos entreprises clientes',
  'dashboard.onboarding.badges': 'Les alertes montrent les documents manquants ou les nouvelles correspondances de subventions',
  'dashboard.onboarding.metrics': 'Aperçu rapide de la performance de votre consultance entière',
  'dashboard.onboarding.start': 'Commencer la Visite',
} as const;